import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';


const Error404View = ({ Error404Actions }) => {
  Error404Actions.show();
  return null;
};

function mapDispatchToProps(dispatch) {
  return {
    Error404Actions: bindActionCreators(Error404Actions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(Error404View);
